import React from 'react';
import Icon from '../../../components/AppIcon';

const PerformanceMetricsCard = ({ title, value, unit, change, trend, target, icon, color = "primary" }) => {
  const isPositive = change >= 0;
  const progressPercentage = target ? Math.min((value / target) * 100, 100) : 0;

  return (
    <div className="bg-card rounded-lg p-6 border border-border agricultural-shadow">
      <div className="flex items-start justify-between mb-4">
        <div className={`p-2 rounded-lg bg-${color}/10`}>
          <Icon name={icon} size={20} className={`text-${color}`} />
        </div>
        <div className="flex items-center space-x-1 text-sm">
          <Icon 
            name={isPositive ? "TrendingUp" : "TrendingDown"} 
            size={16} 
            className={isPositive ? "text-success" : "text-error"} 
          />
          <span className={isPositive ? "text-success" : "text-error"}>
            {Math.abs(change)}%
          </span>
        </div>
      </div>
      <div className="space-y-2">
        <h3 className="text-sm font-medium text-muted-foreground">{title}</h3>
        <div className="flex items-baseline space-x-2">
          <span className="text-2xl font-bold text-foreground">{value}</span>
          <span className="text-sm text-muted-foreground">{unit}</span>
        </div>
        
        {target && (
          <div className="space-y-1">
            <div className="flex justify-between text-xs text-muted-foreground">
              <span>Progress</span>
              <span>{progressPercentage?.toFixed(0)}%</span>
            </div>
            <div className="w-full bg-muted rounded-full h-2">
              <div 
                className={`bg-${color} h-2 rounded-full transition-all duration-300`}
                style={{ width: `${progressPercentage}%` }}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PerformanceMetricsCard;